export default __webpack_public_path__ + "static/media/logoLine.c39a560a.webp";